import React, { useState, useEffect } from 'react';
import axios from 'axios';
import './Footer.css';

const Footer = () => {
  const [profile, setProfile] = useState('');
  const [qqGroups, setQqGroups] = useState([]);
  const [loadingProfile, setLoadingProfile] = useState(true);
  const [loadingGroups, setLoadingGroups] = useState(true);

  useEffect(() => {
    axios.get('/api/profile')
      .then((res) => setProfile(res.data.content || ''))
      .catch(() => {})
      .finally(() => setLoadingProfile(false));
  }, []);

  useEffect(() => {
    axios.get('/api/qq-groups')
      .then((res) => setQqGroups(Array.isArray(res.data) ? res.data : []))
      .catch(() => {})
      .finally(() => setLoadingGroups(false));
  }, []);

  const handleCopyGroupNumber = async (number) => {
    try {
      await navigator.clipboard.writeText(number);
      alert('群号已复制到剪贴板');
    } catch (error) {
      alert('复制失败，请手动复制群号');
    }
  };

  return (
    <footer className="site-footer">
      <div className="footer-inner">
        <div className="footer-section footer-about">
          <h3 className="footer-title">关于我们</h3>
          {loadingProfile ? (
            <div className="footer-loading">加载中...</div>
          ) : (
            <p className="footer-profile">{profile}</p>
          )}
        </div>
        <div className="footer-section footer-qq-groups">
          <h3 className="footer-title">QQ群</h3>
          <p className="footer-qq-tip">请根据实际需要加群</p>
          {loadingGroups ? (
            <div className="footer-loading">加载中...</div>
          ) : qqGroups.length === 0 ? (
            <div className="footer-qq-empty">暂时没有配置QQ群</div>
          ) : (
            <ul className="footer-qq-list">
              {qqGroups.map((group) => (
                <li key={group.id} className="footer-qq-item">
                  <div className="footer-qq-info">
                    <span className="footer-qq-name">{group.name}</span>
                    <span className="footer-qq-number">{group.qq_number}</span>
                  </div>
                  <button
                    type="button"
                    className="footer-qq-copy"
                    onClick={() => handleCopyGroupNumber(group.qq_number)}
                    title="点击复制群号"
                  >
                    复制
                  </button>
                </li>
              ))}
            </ul>
          )}
        </div>
        <div className="footer-section footer-contact">
          <h3 className="footer-title">联系方式</h3>
          <ul className="footer-contact-list">
            <li>
              <span className="footer-label">名称：</span>
              <span className="footer-value">機械寶寶</span>
            </li>
            <li>
              <span className="footer-label">QQ：</span>
              <a href="http://wpa.qq.com/msgrd?v=3&uin=3027211824&site=qq&menu=yes" target="_blank" rel="noopener noreferrer" className="footer-link">
                3027211824
              </a>
            </li>
            <li>
              <span className="footer-label">B站：</span>
              <a href="https://space.bilibili.com/5907872" target="_blank" rel="noopener noreferrer" className="footer-link">
                查看我的空间
              </a>
            </li>
          </ul>
        </div>
      </div>
      <div className="footer-copy">
        © 机械宝宝AI · 专业的AI技术分享与学习平台
      </div>
    </footer>
  );
};

export default Footer;
